"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  loudspeaker: {
    remindText: 'Remind me later',
    dismissText: 'Got it, thanks!',
    viewAllAnnouncementsText: 'Click here to see all announcements',
    readMoreAllAnnouncementsLink: 'Read More'
  }
};
exports.default = _default;